import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { SharedModule } from "./../shared/shared.module";
import { EdgeComponent } from "./edge.component";
import { HistoryModule } from "./history/history.module";
import { HistorySignageModule } from "./historysignage/historysignage.module";
import { LiveModule } from "./live/live.module";
import { MetersModule } from "./meters/meters.module";
import { SignageModule } from "./signage/signage.module";


@NgModule({
    declarations: [
        EdgeComponent,
    ],
    imports: [
        HistoryModule,
        LiveModule,
        SignageModule,
        HistorySignageModule,
        MetersModule,
        SharedModule,
        IonicModule,
    ],
    exports: [
        EdgeComponent,
    ],
})
export class EdgeModule { }
